import axios from "axios";

const servicePrefix = "/galaxy";


// 用户信息保存接口
export function saveUserInfo(parameter) {
    return axios({
        url: servicePrefix + `/userInfo/update`,
        method: 'POST',
        data: parameter
    })
}

// 用户信息查询接口
export function searchUserInfo(id) {
    return axios({
        url: servicePrefix + `/userInfo/info/${id}`,
        method: 'GET'
    })
}

// 通过编号查询用户信息接口
export function getInfoByCode(code) {
    return axios({
        url: servicePrefix + `/userInfo/getInfoByCode/${code}`,
        method: 'GET'
    })
}

// 获取用户对外开放信息
export function getUserOpenData(code) {
    return axios({
        url: servicePrefix + `/userInfo/getUserOpenData?code=${code}`,
        method: 'GET'
    })
}

// 给客户发送邮箱验证信息
export function sendVerificationEmail(email) {
    return axios({
        url: servicePrefix + `/userInfo/sendVerificationEmail?email=${email}`,
        method: 'GET'
    })
}

// 验证用户邮箱
export function verifyEmail(email, code) {
    return axios({
        url: servicePrefix + `/userInfo/verifyEmail?email=${email}&code=${code}`,
        method: 'GET'
    })
}